import { z } from 'zod'
import { dateValueSchema } from './date-value'

export const fileCommonSchema = z.object({
  /** 檔案 Id */
  fileId: z.string(),
  /** 名稱 */
  name: z.string(),
  /** 上傳人員 */
  uploadBy: z.string(),
  /** 上傳時間 */
  uploadTime: dateValueSchema,
  /** 圖片文字描述 */
  // 待全系統圖片上傳功能皆補上 description 再拔除 optional
  description: z.string().optional()
})

export interface FileCommon extends z.infer<typeof fileCommonSchema> {}
